import React, { useContext } from 'react';
import { PinAngle, PinAngleFill } from 'react-bootstrap-icons';
import axios from 'axios';
import { ReportContext } from '../context/ReportProvider';

interface PinReportProps {
  reportId: number;
  userId: number;
  reportName?: string;
}

const PinReport: React.FC<PinReportProps> = ({ reportId, userId, reportName }) => {
  const apiUrl = process.env.REACT_APP_REPORT_API_URL;
  const reportContext = useContext(ReportContext);

  const handlePinClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const api = reportContext?.isPinReport ? apiUrl + 'removefavoritereportforuser' : apiUrl + 'addfavoritereportforuser';

    axios.post(api, { userid: userId, reportid: reportId })
      .then(res => {
        if (res.status === 200) {
          reportContext?.setFavoriteListUpdates((prev: any) => !prev);

        }
      })
      .catch((err) => {
        console.log('error message:', err);
      });
  };

  return (
    <>
      <button className="btn btn-link text-primary" onClick={handlePinClick} style={{ textDecoration: 'underline', boxShadow: 'none' }}>
        {reportContext?.isPinReport ? <PinAngleFill className="mr-2" /> : <PinAngle className="mr-2" />}
        {reportContext?.isPinReport ? 'Unpin Report' : 'Pin Report'}
      </button>

    </>
  );
};

export default PinReport;

